import {Component, input} from '@angular/core';

/** Error · Waarschuwing · Goed (wider) · Waarschuwing · Error, above the four limit fields. */
@Component({
    selector: 'app-threshold-bar',
    templateUrl: './threshold-bar.component.html',
    styles: `
        :host {
            display: grid;
            grid-template-columns: 1fr 1fr 1.4fr 1fr 1fr;
            border-radius: 6px;
            overflow: hidden;
            font-size: 12px;
            font-weight: 500;
            text-align: center;
        }

        div {
            padding: 8px 4px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .error {
            background: #fde2e1;
            color: #a61b1b;
        }

        .warn {
            background: #fff0d6;
            color: #8a5300;
        }

        .ok {
            background: #d9f5e6;
            color: #136b42;
        }
    `,
    host: {
        'aria-hidden': 'true'
    }
})
export class ThresholdBarComponent {
    readonly labels = input(['Error', 'Waarschuwing', 'Goed', 'Waarschuwing', 'Error']);
}
